module.exports = __webpack_public_path__ + "img/charm_4.f5117f83.svg";